<template>
  <div class="home">
    <div class="home__slideshows">
      <slideshows></slideshows>
    </div>
    <div class="home__information">
      <information></information>
    </div>
  </div>
</template>

<script>
import Information from './Information.vue'
import Slideshows from './Slideshows.vue'

export default {
  name: 'home',
  components: {
    'information': Information,
    'slideshows': Slideshows
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
  @import '../assets/styles/base';

  .home {
    display: grid;

    > * {
      grid-column: 1 / -1;
      grid-row: 1 / -1;
    }

    &__slideshows {
      position: relative;
      z-index: 1;
    }

    &__information {
      justify-self: start;
      align-self: start;
      position: relative;
      z-index: 2;
      color: var(--white);
      padding: var(--padding);
    }
  }
</style>



// WEBPACK FOOTER //
// client/components/Home.vue